import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../../../../components/Button'
import Field from '../../../../../../components/Form/Field'
import { NAME } from '../../../fields'

import useStyles from '../../../../../../styles/common/stepForms'

function NameStep({ formik, handleStepChange }) {
  const { t } = useTranslation()
  const classes = useStyles()

  const stepFields = [NAME]

  const handleContinue = () => {
    handleStepChange(stepFields)
  }

  return (
    <>
      <div className={classes.stepTitle}>{t('Give the new ad a name')}</div>
      <div className={classes.stepBody}>
        <Field formik={formik} name={NAME} placeholder={t('Ad Name')} autoComplete="off" />
      </div>
      <div className={classes.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default NameStep
